module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// McBlog_PostWindow Widget

(function (fox, $, undefined) {
	'use strict';
	
	fox.registerWidget('McBlog_PostWindow', {

		configure: function () {
			this.opened = false;
			this.POSTDATA = null;
			this._collection = [];
			this.showEffect = '';

			this.registerOptions('', {
				widgets: {
					shareThis: {
						widget: 'McBlog_ShareThis',
						'onShareClick.target': '.mcb-post-share-icon'
					},
					postBody: {
						widget: 'Widget',
						autoRender: false,
						manualRender: true,
						'embed.container': '.mcb-post-body',
						template: 'mcBlog_post_window_body',
						'hooks.onStartRendering': '@parent:bodyOnStartRendering',
						'hooks.onStopRendering': '@parent:bodyOnStopRendering',
						handleWom: {
							addedToDom: {
								event: 'addedToDom',
								widget: '@this',
								callback: function () {
									if ($(document).scrollTop() > $(this.element[0]).scrollTop() + 100) {
										$('body, html').animate({
											scrollTop: 0
										}, 300);
									}
								}
							}
						},
						handleDom: {
							submit: {
								event: 'click',
								target: '#add-comment',
								callback: '@parent:_submit'
							},
						}
					},
					commentForm: {
						widget: 'Form',
						loadValuesOnRun: false,
						container: '@parent #postBody',
						autoSubmit: false,
						formElements: {
							comment: {
								element: '[name=comment]',
								autoApply: true,
								defaultValue: ''
							}
						},
						
						methods: {
							sendMethod: 'post',
							send: 'McBlog_Comments.post',
							transitParameters: {
								lang: fox.i18n.lang
							}
						},
						responseCallback: fox.bind(this.onPostResponse, this),
						'hooks.onStopPrepareValues': '@parent:onStopPrepareValues',
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							requiredFields: ['comment'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Minimum 1 letters'
							}]
						}
					}
				},
				embed: {
					container: 'body',
					widget: '@root',
					location: 'lastChild'
				},
				manualRender: true,
				template: 'mcBlog_post_window',
				handleDom: {
					closeWindow: {
						event: 'click',
						target: ['.mcb-overlay', '.mcb-post-window-close'],
						callback: 'hide'
					},
					leaveComment: {
						event: 'click',
						target: '#leave-comment',
						callback: function (el, al, performer) {
							$(performer.rwom1('#postBody').dom1(['[data-el-id=', $(el).attr('id'), ']'].join(''))).focus();
						}
					},
					onArrClick: {
						event: 'click',
						target: '.key.normal',
						callback: 'loadPost'
					},
					likeThisPost: {
						event: 'click',
						target: '#like-this-post',
						callback: 'likeThisPost'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			if (!fox.site.member) {
				this.registerOptions('#commentForm', {
					formElements: {
						name: {
							element: '[name=userName]',
							autoApply: true
						},
						email: {
							element: '[name=email]',
							autoApply: true,
							validate: [{validator: 'regexp', options: {type: 'email'}, message: 'Wrong email format'}]
						},
						captcha: {
							element: '[name=captcha]',
							autoApply: true
						},
						consent_tos: {
							element: '[name=consent_tos]',
							autoApply: true,
							validate: [{
								validator: 'regexp',
								options: {
									type: 'email'
								},
								message: 'Wrong email format'
							}]
						}
					}
				});

				this.registerOptions('#commentForm #validator', {
					requiredFields: ['comment', 'name', 'email', 'captcha']
				});

				this.registerOptions('#postBody', {
					'widgets.captchaImg': {
						widget: 'Captcha',
						captchaAlias: 'mcBlog_addComment',
						'embed.container': '#cpth',
						'handleDom.reloadImg': {
							event: 'click',
							target: 'img',
							callback: 'loadCaptcha'
						}
					}
				});
			}

			this._readyToRender = false;
			this.ls = new fox.LocalStorageObjectService({lsLabel: '_rtp_'});
			this.addDocumentListener();
		
			this.callParent('init', arguments);
		},

		bodyOnStartRendering: function () {
			this.rwom1('#postBody').setTemplateOptions(this.POSTDATA);
		},

		bodyOnStopRendering: function () {
			$(this.rwom1('#postBody').dom1('.mcb-fast-animated')).addClass(this.showEffect);
		},

		showPost: function (showEffect) {
			this.showEffect = showEffect;

			this.rwom1('#postBody').render();

			if (this.isEmbedded()) {
				this.setSdbData();

				return this;
			}

			this.waitEvent(this, 'addedToDom', 'setSdbData');

			return this;
		},

		setSdbData: function () {
			var $likes, $comments, $avatar, $screenName, $likeBtn, clientId;

			$avatar = $(this.dom1('.mcb-rep-avatar img'));
			$screenName = $(this.dom1('.mcb-name'));
			$likes = $(this.dom1('#sdb-post-likes'));
			$comments = $(this.dom1('#sdb-post-comments'));
			$likeBtn = $likes.parent().find('.fqb-btn');

			$likes.text(this.POSTDATA._rating.voters || 0);
			$comments.text(this.POSTDATA._comments.collection.length || 0);
			$avatar.attr('src', this.POSTDATA.avatar);
			$screenName.text(this.POSTDATA.screenName || 'No Name');

			clientId = 'guest';

			if (fox.site.member) {
				clientId = fox.site.member.getObjectValue('id');
			}

			if (this.ls.getItem([this.POSTDATA.id, clientId].join(':'))) {
				$likeBtn.prop('disabled', true);
			} else {
				$likeBtn.prop('disabled', false);
			}

			return this;
		},

		setPostData: function (data, collection) {
			this.POSTDATA = data;
			if (typeof collection !== 'undefined') {
				this._collection = collection;
			}

			return this;
		},

		addDocumentListener: function () {
			this.addDomHandler({
				event: 'scroll',
				target: document,
				eventChecker: fox.bind(function () {return this.opened;}, this),
				callback: 'onScroll'
			}, 'onScroll');

			this.addDomHandler({
				event: 'keydown',
				target: document,
				eventChecker: fox.bind(function (event) {
					return this.opened && (event.keyCode === 39 || event.keyCode === 37);
				}, this),
				callback: 'loadPost'
			}, 'onKeyPress');

			return this;
		},

		show: function () {
			return !this.opened && this.render();
		},

		hide: function () {
			fox.Navigator.update({0: 'mc-blog'});
			
			return this.opened && this.removeFromDom();
		},
		
		_submit: function (elt, alias, w, e) {
				var form = this.wom1('#commentForm');
				if (!fox.site.member){
					var check = fox.dom.sel1('#consent_tos');
					if (check._node.checked) {
						form._submit();
						return true;
					} else {
						check.addClass('error');
						fox.site.wait(check, 'click', function(elt){
							elt.removeClass('error');
						});
						return false;
					}
				}

			form._submit();
			
		},
		freezWrapper: function (op) {
			var $wrapper;

			$wrapper = $(fox.dom.selectFirst('.wrapper', this.visualParent.element));

			$wrapper.css({
				top: op ? -$(document).scrollTop() : 'auto',
				position: op ? 'fixed' : 'relative',
				width: op ? '100%' : 'auto',
				heigth: op ? '100%' : 'auto'
			});
		},

		render: function () {
			if (this.opened === true) {return;}

			this.showPost().freezWrapper(true);
			this.opened = true;

		
			this.callParent('render', arguments);
		},

		removeFromDom: function () {
			this.freezWrapper();
			this.opened = false;
		
			this.callParent('removeFromDom', arguments);
		},

		onScroll: function (event) {
			var $sdb = $(this.dom1('.mcb-post-sidebar'));

			if (!$sdb.parent().offset() ||
				$(document).width() < 767 ||
				$(document).height() <= 480) {return;}

			if ($(document).scrollTop() > $sdb.parent().offset().top) {
				$sdb.css({
					width: $sdb.width(),
					position: 'fixed',
					right: 'auto',
					top: 0
				});
			} else {
				$sdb.css({
					width: '30%',
					position: 'absolute',
					right: 0
				});
			}
		},

		loadPost: function (node, alias, scope, event) {
			var keyBinding, parentW, curIndx, elData, showEffect, collection;

			parentW = this.getParent();

			keyBinding = {
				37: '[data-keycode="37"]',
				39: '[data-keycode="39"]'
			};

			collection = this._collection.length ? this._collection : this.getParent()._collection;

			if (node !== document) {
				elData = window.parseInt(node.getAttribute('data-keycode'));
			}

			$(this.dom1(keyBinding[event.keyCode])).addClass(function () {
				setTimeout(fox.bind(function () {
					$(this).removeClass('active');
				}, this), 300);

				return 'active';
			});

			if (collection.length) {
				fox.each(collection, function (item, i) {
					if (item.id === this.POSTDATA.id) {
						curIndx = i;
					}
				}, this);
			}

			if (curIndx !== undefined && curIndx !== -1) {
				if (event.keyCode === 37 || elData === 37) {
					curIndx--;
					showEffect = 'fadeInLeft';
				} else if (event.keyCode === 39 || elData === 39) {
					curIndx++;
					showEffect = 'fadeInRight';
				}

				if (collection[curIndx]) {
					this.setPostData(fox.clone(collection[curIndx]));

					fox.Navigator.set(1, this.POSTDATA.id);
					fox.Navigator.set(2, fox.utils.toNavigatorAlias(this.POSTDATA.title));
				}
			}
		},

		likeThisPost: function () {
			var postId, sendData, ls, clientId, postFromC;

			postId = this.POSTDATA.id;
			clientId = 'guest';

			sendData = {
				targetId: postId,
				value: 5,
				isHidePreloader: true,
				subject: 'blog'
			};

			if (fox.site.member) {
				clientId = fox.site.member.getObjectValue('id');
			}

			if (!this.ls.getItem([postId, clientId].join(':'))) {
				this.ls.setItem([postId, clientId].join(':'), 1);

				this.POSTDATA._rating.voters++;

				postFromC = this.getParent().getPostFromCollection(this.POSTDATA.id);

				if (postFromC) {
					postFromC.postData._rating.voters++;
				}

				this.showPost();

				this.getApi('ratePost', {method: 'McBlog_Rater.rate'}).send(sendData, false);
			}
		},

		onPostResponse: function (res) {
			var parent, postFromC;

			res = res.answer;

			if (!fox.site.member) {
				this.rwom1('#postBody #captchaImg').loadCaptcha();
			}

			if (res.status === false) {
				if (res.code === 2) {
					fox.dom.addClass('error', this.rwom1('#commentForm #captcha').formElement);
				}

				return;
			}

			parent = this.getParent();
			postFromC = parent.getPostFromCollection(this.POSTDATA.id);

			if (postFromC) {
				postFromC.postData._comments.collection.unshift(res.response);
			} else {
				this.POSTDATA._comments.collection.unshift(res.response);
			}

			this.showPost();
			this.rwom1('#commentForm').built();
		},

		onStopPrepareValues: function () {
			var f;

			f = this.rwom1('#commentForm');

			if (f._preparedValues.hasOwnProperty('captcha')) {
				f._preparedValues.captchaId = this.rwom1('#postBody #captchaImg').captchaId;
			}

			f._preparedValues.targetId = this.POSTDATA.id;
			f._preparedValues.transitParameters = {lang:  fox.i18n.lang};
		}

	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/sitepage/mcBlog/postWindow.js
// module id = 475
// module chunks = 2